import React from "react";
import SEO from "../components/SEO";
import { Shield } from "lucide-react";

const Privacy = () => (
  <div className="relative min-h-screen bg-[#0B0F19] text-white">
    <SEO title="Privacy Policy - QryptShield" />
    <div className="absolute inset-0 z-0 pointer-events-none">
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[450px] bg-blue-600/20 rounded-[100%] blur-[120px]" />
    </div>

    <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-10">
      <div className="space-y-3 text-center mt-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-300 text-xs font-semibold">
          <Shield className="w-4 h-4" /> Privacy Policy
        </div>
        <h1 className="text-4xl font-bold">Your Data, Your Control</h1>
        <p className="text-gray-400 max-w-3xl mx-auto">
          We protect customer data with strict access controls, encryption in
          transit and at rest, and zero sharing with third parties for
          advertising.
        </p>
      </div>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-6 shadow-xl">
        {[
          {
            title: "Data Collection",
            body: "We collect only what is necessary to deliver and secure the service: account info, billing details, and operational telemetry with minimal identifiers.",
          },
          {
            title: "Encryption",
            body: "All traffic is encrypted in transit (TLS 1.3) and sensitive data is encrypted at rest with managed keys and strict access policies.",
          },
          {
            title: "Access Control",
            body: "Least-privilege access, MFA for admins, audited actions, and regular key rotation safeguard your environment.",
          },
          {
            title: "Data Retention",
            body: "Operational logs are retained only as long as needed for security and compliance, then purged securely.",
          },
          {
            title: "Your Rights",
            body: "You can request data export or deletion at any time by contacting info@qryptshield.com.",
          },
        ].map((item) => (
          <div key={item.title} className="space-y-2">
            <h2 className="text-xl font-semibold text-white">{item.title}</h2>
            <p className="text-gray-300 text-sm leading-relaxed">{item.body}</p>
          </div>
        ))}
      </div>

      <div className="bg-gradient-to-r from-gray-900 to-blue-900/30 border border-white/10 rounded-2xl p-6 text-center space-y-3">
        <h3 className="text-xl font-bold">Questions about privacy?</h3>
        <p className="text-gray-400 text-sm">
          Email us at info@qryptshield.com. We respond within one business day.
        </p>
      </div>
    </div>
  </div>
);

export default Privacy;
